import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './test.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
  Heading4,
} from '../../../../landingComponents/typography';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';
import LandingButton from 'src/components/landingComponents/button';
import testTable from 'src/assets/img/landing/testTable.png';

const OakInfo = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Heading4 className={styles.header} accent>
        Общий анализ крови
      </Heading4>
      <div className={styles.middle}>
        <Left />
        <Right />
      </div>
      <div className={styles.bottom}>
        <SubTitle accent>
          Этот анализ — первый шаг к пониманию состояния вашего здоровья и
          определению дальнейших действий
        </SubTitle>
        <LandingButton variant="contained" href="/questions">
          <Button>Загрузить анализы</Button>
        </LandingButton>
      </div>
    </CommonLandingContainer>
  );
};

export default OakInfo;

const Left = () => {
  return (
    <AnimatedBox className={getClassName([styles.left])}>
      <Title accent>Общий анализ крови (ОАК) — это</Title>
      <div className={styles.infoText}>
        <SecondaryText>
          Комплексный тест, который предоставляет много важной информации, но
          сам по себе не дает полной клинической картины. Однако ОАК помогает
          выявить скрытые проблемы со здоровьем и наметить дальнейшие шаги для
          обследования.
        </SecondaryText>
        <SecondaryText>
          Наша система, анализируя ОАК, часто формулирует выводы с фразой
          «соответствует части критериев для...». Мы обязательно напишем, какие
          еще критерии существуют и укажем специалистов к которым стоит
          обратиться
        </SecondaryText>
      </div>
    </AnimatedBox>
  );
};

const Right = () => {
  return (
    <AnimatedBox className={getClassName([styles.right])}>
      <div className={styles.rightText}>
        <Title accent>С помощью ОАК можно выявить:</Title>
        <div className={styles.infoText}>
          <TestDescription
            accentText="Анемию "
            text=" — за счет анализа уровня гемоглобина, эритроцитов, их цвета, размера и других параметров"
          ></TestDescription>
          <TestDescription
            accentText="Воспаление или аллергическую реакцию "
            text=" — через оценку показателей нейтрофилов, базофилов, эозинофилов"
          ></TestDescription>
          <TestDescription
            accentText="Другие проблемы,"
            text=" которые проявляются в нарушении пропорций компонентов крови"
          ></TestDescription>
        </div>
      </div>
      <div className={styles.rightImageContainer}>
        <img
          className={styles.rightImage}
          src={testTable}
          alt="таблица анализов"
        />
      </div>
    </AnimatedBox>
  );
};

export const TestDescription = ({ accentText, text }) => {
  return (
    <SecondaryText>
      <span className={styles.instrAccentText}>{accentText}</span>
      {text}
    </SecondaryText>
  );
};
